import React, { useEffect, useState } from "react";
import "./Personal_Info.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlus,
  faPencil,
  faPencilSquare,
  faPenToSquare,
  faPlus,
  faTrash,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Blue_Round_Btn from "../../../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import New_Address_Modal from "../../../common-components/common-modals/new_address_modal/New_Address_Modal";
import Success_Modal from "../../../common-components/common-modals/success_modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserInfo,
  updateUserInfo,
} from "../../../../features/user/userSlice";
import {
  formatDate,
  RegxExpression,
  Select2Data,
} from "../../../../utils/common";
import { getAllGender } from "../../../../features/master/masterSlice";
import {
  deleteAddress,
  getAllOrderAddress,
} from "../../../../features/order/orderSlice";
import Edit_Address_Modal from "../../../common-components/common-modals/new_address_modal/Edit_Address_Modal";

const Personal_Info = () => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm({});

  const dispatch = useDispatch();
  const [editId, setEditId] = useState();
  const [successmodal, setSuccessmodal] = useState(false);
  const [deleteModal, setDeletemodal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showEditAddressModal, setShowEditAddressModal] = useState(false);
  const [genders, setGenders] = useState(false);
  const is_signin = useSelector((state) => state.auth.is_signin);

  const countries = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const onSubmit = async (data) => {
    // if (!isEdit) {
    //   setIsEdit(true);
    // } else {
    const sendData = {
      name: data?.name,
      email: data?.email,
      contact_no: data?.contact_no,
      last_name: data?.last_name,
      date_of_birth: data?.date_of_birth,
      gender_id: data?.gender_id?.value,
    };
    const res = await dispatch(updateUserInfo({ data: sendData }));
    console.log(res, "resresresres");

    if (res.meta?.requestStatus === "fulfilled") {
      setSuccessmodal(true);
      // setIsEdit(false)
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors?.email) {
        setError("email", {
          type: "server",
          message: res.payload.errors.email,
        });
      }
      if (res.payload?.errors?.password) {
        setError("password", {
          type: "server",
          message: res.payload.errors.password,
        });
      }
      // }
    }
  };

  const user = useSelector((state) => state.user.userInfo);
  const getUser = async () => {
    const data = await dispatch(getUserInfo());

    if (data.meta?.requestStatus === "fulfilled") {
      if (user) {
        reset(data?.payload);
        setValue("date_of_birth", formatDate(data?.payload?.date_of_birth));
        const genderdata = await dispatch(getAllGender());
        const gender = await Select2Data(genderdata?.payload, "gender_id");
        setGenders(gender);
      }
    }
  };

  useEffect(() => {
    if (is_signin) {
      getUser();
    }
  }, [is_signin, dispatch]);

  const allOrdersAddress = useSelector((state) => state.order.allOrdersAddress);
  useEffect(() => {
    dispatch(getAllOrderAddress());
  }, [dispatch]);

  const DeleteAdrress = async (id) => {
    const res = await dispatch(deleteAddress({ id: id }));
    console.log(res, "res res");

    if (res.meta?.requestStatus === "fulfilled") {
      // props?.onHide();
      await dispatch(getAllOrderAddress());

      setDeletemodal(true);
      setTimeout(() => {
        setDeletemodal(false);
      }, 2000);
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };
 const today = new Date().toISOString().split("T")[0];


  return (
    <section className="Personal_Info">
      <div className="personal_info_form">
        <Form>
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>First name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter First Name"
                  {...register("name", {
                    required: "Name is required",
                  })}
                />
                {errors?.name && (
                  <sup className="text-danger">{errors?.name?.message}</sup>
                )}
              </Form.Group>
            </div>

            {/* <div className="col-lg-4 col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Last name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Last name"
                  {...register("last_name", {
                    required: "Last Name is required",
                  })}
                />
                {errors?.last_name && (
                  <sup className="text-danger">
                    {errors?.last_name?.message}
                  </sup>
                )}
              </Form.Group>
            </div> */}

            <div className="col-lg-4 col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: RegxExpression.email,
                      message: "Invalid email address",
                    },
                  })}
                />
                {errors?.email && (
                  <sup className="text-danger">{errors?.email?.message}</sup>
                )}
              </Form.Group>
            </div>

            <div className="col-lg-4 col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Contact number</Form.Label>
                <Form.Control
                  type="text"
                  maxLength={10}
                  placeholder="Enter mobile number"
                  {...register("contact_no", {
                    required: "Mobile Number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter valid 10-digit mobile number",
                    },
                  })}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault(); // blocks non-numeric input
                    }
                  }}
                />
                {errors?.contact_no && (
                  <sup className="text-danger">
                    {errors?.contact_no?.message}
                  </sup>
                )}
              </Form.Group>
            </div>

            <div className="col-lg-4 col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Date of birth</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter Date of birth"
                   max={today}
                  {...register("date_of_birth", {
                    required: "Date of birth is required",
                    // validate: {
                    //   notFuture: (value) => {
                    //     const selected = new Date(value);
                    //     const today = new Date();

                    //     if (selected > today) {
                    //       return "Date of birth cannot be in the future";
                    //     }
                    //     return true;
                    //   },
                    //   minAge: (value) => {
                    //     const selected = new Date(value);
                    //     const today = new Date();
                    //     const age =
                    //       today.getFullYear() - selected.getFullYear();
                    //     const monthDiff =
                    //       today.getMonth() - selected.getMonth();
                    //     const dayDiff = today.getDate() - selected.getDate();

                    //     const isUnder18 =
                    //       age < 18 ||
                    //       (age === 18 &&
                    //         (monthDiff < 0 ||
                    //           (monthDiff === 0 && dayDiff < 0)));

                    //     if (isUnder18) {
                    //       return "Minimum age should be 18 years";
                    //     }
                    //     return true;
                    //   },
                    // },
                  })}
                />

                {errors?.date_of_birth && (
                  <sup className="text-danger">
                    {errors?.date_of_birth?.message}
                  </sup>
                )}
              </Form.Group>
            </div>

            <div className="col-lg-4 col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Gender</Form.Label>
                <Controller
                  className="Select_Dropdown_holder"
                  name="gender_id" // Form field name
                  control={control}
                  rules={{ required: "Gender is required" }}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.gender_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={genders}
                    />
                  )}
                />
                {errors?.gender_id && (
                  <sup className="text-danger">
                    {errors?.gender_id?.message}
                  </sup>
                )}
              </Form.Group>
            </div>
            <div className="btn_holder">
              <Blue_Round_Btn
                // btnText={isEdit ? "Save" : "Edit Information"}
                btnText={"Save"}
                onClick={handleSubmit(onSubmit)}
              />
            </div>

            {allOrdersAddress?.data?.map((item) => (
              <div className="col-lg-4 col-sm-6">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <div className="title_icon_holder">
                    <Form.Label>{item?.Address_Type?.name} address</Form.Label>
                    <div className="edit_icon_holder">
                      <FontAwesomeIcon
                        className="card_icon edit_icons"
                        icon={faPenToSquare}
                        onClick={() => {
                          setEditId(item?.id);
                          setShowEditAddressModal(true);
                        }}
                      />
                      <FontAwesomeIcon
                        onClick={() => {
                          DeleteAdrress(item?.id);
                        }}
                        className="card_icon delete_icons"
                        icon={faTrashCan}
                      />
                    </div>
                  </div>

                  <Form.Control
                    as={"textarea"}
                    type="text"
                    disabled
                    placeholder="Enter home Address"
                    value={`${item?.floor}, ${item?.building}, ${item?.direction}, ${item?.street}, ${item?.Users_Address_Detail?.City?.name} - ${item?.Users_Address_Detail?.Pincode?.name}`}

                    // {...register("home_address", {
                    //   // required: "Home Address is required",
                    // })}
                  />
                  {/* {errors?.home_address && (
                    <sup className="text-danger">
                      {errors?.home_address?.message}
                    </sup>
                  )} */}
                </Form.Group>
              </div>
            ))}

            {/* <div className="col-lg-4 col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                {" "}
                <div className="title_icon_holder">
                  <Form.Label>Office address</Form.Label>
                  <div className="edit_icon_holder">
                    <FontAwesomeIcon
                      className="card_icon edit_icons"
                      icon={faPenToSquare}
                    />
                    <FontAwesomeIcon
                      className="card_icon delete_icons"
                      icon={faTrashCan}
                    />
                  </div>
                </div>
                <Form.Control
                  as={"textarea"}
                  type="text"
                  disabled
                  placeholder="Enter office Address"
                
                  // {...register("office_address", {
                  //   // required: "Office Address is required",
                  // })}
                />
              
              </Form.Group>
            </div> */}

            <div className="col-lg-4 col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Add new address</Form.Label>
                <div
                  className="cutom_input_holder address_btn_holder"
                  onClick={() => {
                    setShowAddressModal(true);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon
                      icon={faCirclePlus}
                      className="icon_text"
                    />
                  </div>
                </div>

                {errors?.contact_no && (
                  <sup className="text-danger">
                    {errors?.contact_no?.message}
                  </sup>
                )}
              </Form.Group>
            </div>
          </div>
        </Form>
      </div>

      <Success_Modal
        show={successmodal}
        onHide={() => setSuccessmodal(false)}
        successText={"Profile Updated Succcessfully !"}
      />

      <Success_Modal
        show={deleteModal}
        onHide={() => setDeletemodal(false)}
        successText={"Address Delete Succcessfully !"}
      />

      <New_Address_Modal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
      />

      <Edit_Address_Modal
        Id={editId}
        show={showEditAddressModal}
        onHide={() => setShowEditAddressModal(false)}
      />
    </section>
  );
};
export default Personal_Info;
